import { img } from "../lib/media";

export function PoetaSection() {
	return (
		<section className="section section--alt">
			<div className="content-wrap--wide reveal">
				<div className="side-img side-img--narrow side-img--right">
					<div className="side-img__img">
						<img src={img("danyInicios7.jpg")} alt="Stefanny en sus inicios" />
					</div>
					<div className="side-img__text">
						<div className="side-img__label">Poeta y guerrera apasionada</div>
						<h3 className="side-img__heading">
							El poder del lenguaje y las palabras la definieron.
						</h3>
						<div className="side-img__body">
							<p>
								La conocí desde los 15 años. Fue una amiga muy cercana, luego mi
								compañera de vida y la madre de nuestros hijos. Desde aquellos días
								en la preparatoria, Stefanny formaba parte de un grupo de activismo
								llamado "Cuatlicue", conocido por su participación en marchas y
								movimientos en defensa de los derechos estudiantiles. A pesar de su
								constante inquietud frente a las injusticias cotidianas, siempre
								mostró una gran disposición para brindar apoyo y escucha, incluso
								cuando atravesaba sus propios desafíos.
							</p>
							<p>
								Cursó varios semestres en Letras Clásicas en la UNAM, pero optó por
								estudiar Psicología en la UAM, donde encontró una conexión más
								profunda con sus intereses y valores. Gracias a su dedicación,
								obtuvo una beca para estudiar Latín, alcanzando el nivel de poder
								recitarlo con fluidez. Su talento para la poesía fue reconocido al
								ser seleccionada para el Festival Cultural Interfaz del ISSSTE
								<sup>
									<a href="#ref1">[1]</a>
								</sup>
								.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
